import { useEffect, useState, useContext, useRef } from "react";
import { createBrowserRouter, RouterProvider, useNavigate } from "react-router";
import axios from 'axios';

import { AppContext } from '../../../context.js';

import Helmet from "../../components/helmet.js";
import { Status, Button, Counter } from '../../components/component.js';

function UserCreate() {
  const context = useContext(AppContext);

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [lastName, setLastName] = useState("");
  const [speciality, setSpeciality] = useState("");

  const [phone, setPhone] = useState("");
  
  const [provider, setProvider] = useState(false);
  const [npi, setNpi] = useState("");

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");

  const [staffRole, setStaffRole] = useState("navigator");

  function createUser() {
    let u = context.addSpiner();
    axios.post('/api/admin/physicians/create', {
      firstName: firstName ? firstName : null,
      middleName: middleName ? middleName : null,
      lastName: lastName ? lastName : null,
      speciality: speciality ? speciality : null,

      phone: phone ? phone : null,

      provider: provider,
      npi: npi ? npi : null,

      email: email ? email : null,
      password: password ? password : null,
      repeatPassword: repeatPassword ? repeatPassword : null,

      staffRole: staffRole,
    }).then((response) => {
      navigate('/settings/users');
    }).catch((e) => {
      context.addError(e);
    }).finally(() => {
      context.removeSpiner(u);
    });
  }

  if (loading) {
    return <></>;
  }

  return (
    <>
      <Helmet title="Settings | User Create" />

      <div className="container-fluid">
        <div className="row mb-4">
          <div className="col-xs-12 col-lg-offset-3 col-lg-6">
            <div className="d-flex justify-content-between align-items-center">
              <div className="">
                <div className="typo-hero-small">User Create</div>
                <div className="typo-normal-175">Create a new user account for a physician</div>
              </div>
              <div className="w-25 text-end">
                {/* <div className="item typo-normal-150 ms-2" onClick={() => navigate('/patient/create')}><FilePlus height={16} width={16} background={'none'} fill={'grey'} /> Create Patient</div> */}
              </div>
            </div>
          </div>
        </div>

        <div className="row mb-4">
          <div className="col-xs-12 col-lg-offset-3 col-lg-6">

            {/* Personal Information */}
            <div className="card mb-4">
              <div className="card-header sm">
                <div className="typo-strong-200">Personal Information</div>
              </div>
              
              <div className="card-header sm">
                <div className="row mb-3">
                  <div className="col-xs-12 col-lg-4">
                    <div className="typo-strong-150">First Name <span className="text-red">*</span></div>
                    <input type="text" placeholder="" value={firstName} onChange={(e) => setFirstName(e.target.value)} className="input sm typo-normal-150 w-100" />
                  </div>
                  <div className="col-xs-12 col-lg-4">
                    <div className="typo-strong-150">Middle Name</div>
                    <input type="text" placeholder="" value={middleName} onChange={(e) => setMiddleName(e.target.value)} className="input sm typo-normal-150 w-100" />
                  </div>
                  <div className="col-xs-12 col-lg-4">
                    <div className="typo-strong-150">Last Name <span className="text-red">*</span></div>
                    <input type="text" placeholder="" value={lastName} onChange={(e) => setLastName(e.target.value)} className="input sm typo-normal-150 w-100" />
                  </div>
                </div>

                <div className="row">
                  <div className="col-xs-12 col-lg-4">
                    <div className="typo-strong-150">Speciality</div>
                    <input type="text" placeholder="" value={speciality} onChange={(e) => setSpeciality(e.target.value)} className="input sm typo-normal-150 w-100" />
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Information */}
            <div className="card mb-4">
              <div className="card-header sm">
                <div className="typo-strong-200">Contact Information</div>
              </div>
              
              <div className="card-header sm">
                <div className="row">
                  <div className="col-xs-12 col-lg-4">
                    <div className="typo-strong-150">Phone</div>
                    <input type="text" placeholder="" value={phone} onChange={(e) => setPhone(e.target.value)} className="input sm typo-normal-150 w-100" />
                  </div>
                </div>
              </div>
            </div>

            {/* Provider Information */}
            <div className="card mb-4">
              <div className="card-header sm">
                <div className="typo-strong-200">Provider Information</div>
              </div>
              
              <div className="card-header sm">
                <div className="row">
                  <div className="col-xs-12 col-lg-4">
                    <div className="typo-strong-150">Provider <span className="text-red">*</span></div>
                    <div className={"item typo-normal-150 me-1 " + (provider ? "blue" : "grey")} onClick={() => setProvider(true)}>Yes</div>
                    <div className={"item typo-normal-150 me-1 " + (provider ? "grey" : "blue")} onClick={() => setProvider(false)}>No</div>
                  </div>
                  <div className="col-xs-12 col-lg-4">
                    <div className="typo-strong-150">NPI</div>
                    <input type="text" placeholder="" value={npi} onChange={(e) => setNpi(e.target.value)} className="input sm typo-normal-150 w-100" />
                  </div>
                </div>
              </div>
            </div>

            {/* Authorization Information */}
            <div className="card">
              <div className="card-header sm">
                <div className="typo-strong-200">Authorization Information</div>
              </div>
              
              <div className="card-header sm">
                <div className="row">
                  <div className="col-xs-12 col-lg-4">
                    <div className="typo-strong-150">Email <span className="text-red">*</span></div>
                    <input type="text" placeholder="" value={email} onChange={(e) => setEmail(e.target.value)} className="input sm typo-normal-150 w-100" />
                  </div>
                  <div className="col-xs-12 col-lg-4">
                    <div className="typo-strong-150">Password <span className="text-red">*</span></div>
                    <input type="password" placeholder="" value={password} onChange={(e) => setPassword(e.target.value)} className="input sm typo-normal-150 w-100" />
                  </div>
                  <div className="col-xs-12 col-lg-4">
                    <div className="typo-strong-150">Repeat Password <span className="text-red">*</span></div>
                    <input type="password" placeholder="" value={repeatPassword} onChange={(e) => setRepeatPassword(e.target.value)} className="input sm typo-normal-150 w-100" />
                  </div>
                </div>

                {context.isAdmin && (
                  <div className="row mt-3">
                    <div className="col-xs-12 col-lg-8">
                      <div className="typo-strong-150">Role <span className="text-red">*</span></div>
                      <div className={"item typo-normal-150 me-1 " + (staffRole === "navigator" ? "blue" : "grey")} onClick={() => setStaffRole("navigator")}>Navigator</div>
                      <div className={"item typo-normal-150 me-1 " + (staffRole === "admin" ? "blue" : "grey")} onClick={() => setStaffRole("admin")}>Admin</div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-lg-offset-3 col-lg-6 text-end">
            <Button onClick={createUser} color="blue" text="Create" />          
          </div>
        </div>
      </div>
    </>
  );
}

export default UserCreate;